
import * as echarts from 'echarts';
import chinaJson from '../../assets/json/china.json'
echarts.registerMap('china', chinaJson);
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

import moment from 'moment';

import { getProCount, getTypeCount, getDevCount, getDevDis, getDevTop, getPoliceCountAlarm, getProStatus } from "@/api/homePage";
import { getPoliceHisList, getPoliceAlarmToday, getPoliceAlarmProcessToday,getProByDeviceIdent } from "@/api/warning";
import { getEnergyRanking, getCostPercent, getTotalEnergy, getProjectDetail } from "@/api/energy";

export default {
    name: "homePage",
    components: {
        swiper,
        swiperSlide
    },
    data() {
        return {
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                loop: true,
                autoplay: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            },
            projectNum: '',
            deviceNum: '',
            projectStatus: [
                {
                    statusText: '总项目数量',
                    icon: require('../../assets/images/home/project.png'),
                    num: 0,
                }, {
                    statusText: '启动中项目数量',
                    icon: require('../../assets/images/home/started.png'),
                    num: 0,
                }, {
                    statusText: '已停止项目数量',
                    icon: require('../../assets/images/home/notstarted.png'),
                    num: 0,
                },
            ],
            deviceStatus: [
                {
                    text: '总设备数量',
                    number: 0,
                    icon: require('../../assets/images/home/device_all.png'),
                    bgColor: '#00C0FF'
                }, {
                    text: '报警设备数量',
                    number: 0,
                    icon: require('../../assets/images/home/warning.png'),
                    bgColor: '#FB5B79'
                }, {
                    text: '在线设备数量',
                    number: 0,
                    icon: require('../../assets/images/home/online.png'),
                    bgColor: '#26E1AE'
                }, {
                    text: '离线设备数量',
                    number: 0,
                    icon: require('../../assets/images/home/offline.png'),
                    bgColor: '#FD964E'
                    // }, {
                    //     text: '未激活设备数量',
                    //     number: 0,
                    //     icon: require('../../assets/images/home/nonactivated.png'),
                    //     bgColor: '#C6C6C6'
                },
            ],
            typeData: [],
            percentage: 0,
            warningStatus: [
                {
                    text: '今日报警总数',
                    number: 0,
                    bgColor: '#e5f7ff',
                    color: '#00CDFF',
                }, {
                    text: '已处理报警',
                    number: 0,
                    bgColor: '#e5fff6',
                    color: '#00CC8B',
                }, {
                    text: '未处理报警',
                    number: 0,
                    bgColor: '#fce5e5',
                    color: '#E00000',
                },
            ],

            mapData: [
                { name: '北京', id: "BeiJing", value: 0 },
                { name: '天津', id: "TianJin", value: 0 },
                { name: '上海', id: "ShangHai", value: 0 },
                { name: '重庆', id: "ChongQing", value: 0 },
                { name: '河北', id: "HeBei", value: 0 },
                { name: '河南', id: "HeNan", value: 0 },
                { name: '云南', id: "YunNan", value: 0 },
                { name: '辽宁', id: "LiaoNing", value: 0 },
                { name: '黑龙江', id: "HeiLongJiang", value: 0 },
                { name: '湖南', id: "HuNan", value: 0 },
                { name: '安徽', id: "AnHui", value: 0 },
                { name: '山东', id: "ShanDong", value: 0 },
                { name: '新疆', id: "XinJiang", value: 0 },
                { name: '江苏', id: "JiangSu", value: 0 },
                { name: '浙江', id: "ZheJiang", value: 0 },
                { name: '江西', id: "JiangXi", value: 0 },
                { name: '湖北', id: "HuBei", value: 0 },
                { name: '广西', id: "GuangXin", value: 0 },
                { name: '甘肃', id: "GanSu", value: 0 },
                { name: '山西', id: "ShanXi", value: 0 },
                { name: '内蒙古', id: "NeiMengGu", value: 0 },
                { name: '陕西', id: "ShananXi", value: 0 },
                { name: '吉林', id: "JiLin", value: 0 },
                { name: '福建', id: "FuJian", value: 0 },
                { name: '贵州', id: "GuiZhou", value: 0 },
                { name: '广东', id: "GuangDong", value: 0 },
                { name: '青海', id: "QingHai", value: 0 },
                { name: '西藏', id: "XiZang", value: 0 },
                { name: '四川', id: "SiChuan", value: 0 },
                { name: '宁夏', id: "NingXia", value: 0 },
                { name: '海南', id: "HaiNan", value: 0 },
                { name: '台湾', id: "TaiWan", value: 0 },
                { name: '香港', id: "XiangGang", value: 0 },
                { name: '澳门', id: "AoMen", value: 0 },
                { name: '南海诸岛', id: "", value: 0 },
                { name: '散点1', value: 1009, LngAndLat: [113.52, 23.179] },
            ],
            geoCoordMap: {},
            mapColor: ['#002278', '#033a9c', '#0d4fb0', '#1862c1', '#2679d3', '#3a8fe2', '#56a6ed', '#76bdf4', '#97d2fa', '#b1e3fe'],

            regionNameArr: [],
            countArr: [],

            warningData: [],
            timer: null,

            energyRankingName: [],//综合能耗排行
            energyRankingData: [],

            //费用占比
            totleCost: 0,
            costPercentData: [
                { value: 0, name: '水费用' },
                { value: 0, name: '电费用' },
                { value: 0, name: '燃气费用' },
            ],

            //总能耗
            totalData: [
                {
                    imgUrl: require('../../assets/images/energy/water.png'),
                    quantity: 0,
                    text: '用水量（t）'
                }, {
                    imgUrl: require('../../assets/images/energy/electricity.png'),
                    quantity: 0,
                    text: '用电量（kw·h）'
                }, {
                    imgUrl: require('../../assets/images/energy/gas.png'),
                    quantity: 0,
                    text: '用燃气量（m³）'
                },
            ],
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        // let price = this.progressBar.reduce((sum, e) => sum + Number(e.number || 0), 0)
        // this.progressBar.forEach(el => {
        //     el.per = el.number / price * 100
        // });

        this.init()
    },
    mounted() {
        // 设备类型占比
        // this.getTypeCount()

        //能耗统计
        this.getCostPercent()

        this.getDevDis()// 设备地域分布Top10
        this.getEnergyRanking()//能耗排行

    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {

        init() {
            this.getProCount()
            this.getDevCount()
            this.timer = setInterval(() => {
                //总项目数量
                this.getProCount()
                // 设备概况
                this.getDevCount()
            }, 10000)

            this.getDevTop()//设备地图分布

            this.getPoliceHisList()//设备报警历史

            this.getTodayAlarmNumber()

            this.getTotalEnergy()//能耗统计

        },
        //总项目数量
        async getProCount() {
            const res = await getProCount()
            const res1 = await getProStatus()
            if (res.code == 200) {
                this.projectStatus[0].num = res.data
            }
            if (res1.code == 200) {
                this.projectStatus[1].num = res1.data.onlineProCount
                this.projectStatus[2].num = res1.data.offlineProCount
                this.deviceStatus[2].number = res1.data.onlineDevCount //在线 
                this.deviceStatus[3].number = res1.data.offlineDevCount //离线
            }
            // if (res.code == 200 && res1.code == 200) {
            //     this.projectStatus[2].num = res.data - res1.data.onlineProCount
            // }
        },
        // 设备概况
        getDevCount() {
            getDevCount().then(res => {//总设备数据
                if (res.code == 200) {
                    this.deviceNum = res.data.tolNum
                    this.deviceStatus[0].number = res.data.tolNum
                }
            })
            // getProStatus().then(res1 => {//在线统计
            //     if (res1.code == 200) {
            //         this.deviceStatus[2].number = res1.data.onlineDevCount //在线
            //         this.deviceStatus[3].number = res1.data.offlineDevCount //离线
            //     }
            // })
            getPoliceCountAlarm().then(res2 => {
                if (res2.code == 200) {//告警设备数
                    this.deviceStatus[1].number = res2.data
                }
            })
        },

        // 设备地域分布
        async getDevDis() {
            const res = await getDevDis()
            if (res.code == 200) {
                this.regionNameArr = []
                this.countArr = []
                let dataArr = res.data

                dataArr.sort((a, b) => {
                    return a.count - b.count
                })

                dataArr.forEach(el => {
                    this.regionNameArr.push(el.regionName)
                    this.countArr.push(el.count)
                })
                this.getDeviceDistributionEchart()
            }
        },

        async getDevTop() {
            // const res = await getDevTop()
            const res = await getProjectDetail()
            if (res.code == 200) {
                let { data } = res
                this.mapData = []
                this.geoCoordMap = {}
                data.forEach(el => {
                    this.mapData.push({
                        name: el.region_name,
                        // value: el.count,
                        value: el.projectDetailVo,
                        projectName: el.project_name
                    })
                    this.geoCoordMap[el.region_name] = [el.longitude, el.latitude]
                })
                this.getEchartMap()
            }
        },

        //总能耗
        async getTotalEnergy() {
            const res = await getTotalEnergy('day')
            if (res.code == 200) {
                res.data.forEach(el => {
                    if (el.type === '水') { this.totalData[0].quantity = el.value }
                    if (el.type === '电') { this.totalData[1].quantity = el.value }
                    if (el.type === '燃气') { this.totalData[2].quantity = el.value }
                })
            }
        },

        //费用占比
        async getCostPercent() {
            const res = await getCostPercent('day')
            if (res.code == 200) {
                this.totleCost = res.data.totleCost
                this.costPercentData[0].value = res.data.waterPercent
                this.costPercentData[1].value = res.data.electricPercent
                this.costPercentData[2].value = res.data.gasPercent
                this.costOfEchart()
            }
        },

        //费用占比
        costOfEchart() {
            let option = {
                color: ['#00B4FF', '#FFC300', '#F7725B'],
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}：{d}%',
                },
                legend: {
                    orient: 'horizontal',
                    bottom: '7%',
                    data: [
                        {
                            name: '水费用',
                            icon: 'circle',
                        }, {
                            name: '电费用',
                            icon: 'circle',
                        }, {
                            name: '燃气费用',
                            icon: 'circle',
                        },
                    ]
                },
                series: [
                    {
                        name: '费用占比',
                        type: 'pie',
                        // radius: '50%',
                        // center: ['50%', '45%'],
                        radius: ['45%', '60%'],
                        center: ['50%', '43%'],
                        data: this.costPercentData,
                        itemStyle: {
                            borderRadius: "5rpx",
                            borderColor: '#fff',
                            borderWidth: "2rpx"
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        },
                        label: {
                            show: true,
                            formatter: '{b}：{d}%',
                            fontSize: 12,
                            color: '#999'
                        }
                    }
                ]
            };
            let myChart = echarts.init(document.getElementById('costofEchart'));
            myChart.setOption(option);
        },


        async getPoliceHisList() {
            let params = {
                page: 1,
                offset: 1000,
                sortBy: '',
                order: '',
                isRead: '',
                projectId: '', //项目id
                deviceIdent: [], //设备标识

                startTime: moment().subtract(7, "days").format('X'),  //开始时间
                endTime: moment().format('X'), //结束时间
            }
            const res = await getPoliceHisList(params)
            if (res.code == 200) {
                let warningData = []
                let idList = []
                let data = res.data.rows
                data.forEach(el => {
                    let trigAttr = el.trigAttr ? JSON.parse(el.trigAttr) : []
                    let trigAttrName = el.trigAttrName ? JSON.parse(el.trigAttrName) : []
                    let trigCondition = el.trigCondition ? JSON.parse(el.trigCondition) : []
                    let indexArr = this.findall(trigCondition || [], '%s')

                    el.dpName = trigAttrName[0] ? trigAttrName[0] : ''
                    el.dpId = trigAttr[0] ? trigAttr[0] : ''
                    el.sign = trigCondition[1] ? trigCondition[1] : ''
                    el.val = trigCondition[2] ? trigCondition[2] : ''
                    for (let i = 0; i < indexArr.length; i++) {
                        trigCondition.splice(indexArr[i], 1, trigAttrName[i])
                    }
                    // el.triggers = trigCondition.join()
                    // console.log(res.data, 55555555)
                    // res.data.proArr.forEach(item => {
                    //     if (el.deviceIdent === item.deviceIdent) {
                    //         el.proName = item.proName
                    //     }
                    // })

                    warningData.push({
                        createTime: el.createTime,
                        proName: el.proName,
                        deviceIdent:el.deviceIdent,
                        deviceName: el.deviceIdent + '/' + el.deviceName,
                        content: trigCondition.join(''),
                        state: el.process == 0 ? false : true
                    })
                    idList.push(el.deviceIdent)
                })
                this.warningData = warningData
                idList = [...new Set(idList)]
                this.getProByDeviceIdent(idList)
            }
        },

        // 通过设备标识查询所属项目
        getProByDeviceIdent(idList) {
            getProByDeviceIdent(idList).then(res => {
                this.warningData.forEach(item => {
                    res.data.forEach(el => {
                        if (item.deviceIdent === el.deviceIdent) {
                            this.$set(item, 'proName', el.proName)
                        }
                    })
                })
            })
        },

        async getTodayAlarmNumber() {
            const resAll = await getPoliceAlarmToday()
            const res = await getPoliceAlarmProcessToday()
            if (resAll.code === 200 && res.code === 200) {
                this.warningStatus[0].number = resAll.data
                this.warningStatus[1].number = res.data
                this.warningStatus[2].number = resAll.data - res.data

                this.percentage = Object.is(Number((res.data / resAll.data * 100).toFixed(2)), NaN) ? 0 : Number((res.data / resAll.data * 100).toFixed(2))
            }
        },




        //中间的地图
        getEchartMap() {
            let myChart = echarts.init(document.getElementById('echartMap'));

            let data = [
                { name: '海门', value: 9 },
                { name: '鄂尔多斯', value: 12 },
                { name: '招远', value: 12 },
                { name: '舟山', value: 12 },
                { name: '齐齐哈尔', value: 14 },
                { name: '盐城', value: 15 },
                { name: '赤峰', value: 16 },
                { name: '青岛', value: 18 },
                { name: '乳山', value: 18 },
                { name: '金昌', value: 19 },
                { name: '泉州', value: 21 },
                { name: '莱西', value: 21 },
                { name: '日照', value: 21 },
                { name: '胶南', value: 22 },
                { name: '南通', value: 23 },
                { name: '拉萨', value: 24 },
                { name: '云浮', value: 24 },
                { name: '梅州', value: 25 },
                { name: '文登', value: 25 },
                { name: '上海', value: 25 },
                { name: '攀枝花', value: 25 },
                { name: '威海', value: 25 },
                { name: '承德', value: 25 },
                { name: '厦门', value: 26 },
                { name: '汕尾', value: 26 },
                { name: '潮州', value: 26 },
                { name: '丹东', value: 27 },
                { name: '太仓', value: 27 },
                { name: '曲靖', value: 27 },
                { name: '烟台', value: 28 },
                { name: '福州', value: 29 },
                { name: '瓦房店', value: 30 },
                { name: '即墨', value: 30 },
                { name: '抚顺', value: 31 },
                { name: '玉溪', value: 31 },
                { name: '张家口', value: 31 },
                { name: '阳泉', value: 31 },
                { name: '莱州', value: 32 },
                { name: '湖州', value: 32 },
                { name: '汕头', value: 32 },
                { name: '昆山', value: 33 },
                { name: '宁波', value: 33 },
                { name: '湛江', value: 33 },
                { name: '揭阳', value: 34 },
                { name: '荣成', value: 34 },
                { name: '连云港', value: 35 },
                { name: '葫芦岛', value: 35 },
                { name: '常熟', value: 36 },
                { name: '东莞', value: 36 },
                { name: '河源', value: 36 },
                { name: '淮安', value: 36 },
                { name: '泰州', value: 36 },
                { name: '南宁', value: 37 },
                { name: '营口', value: 37 },
                { name: '惠州', value: 37 },
                { name: '江阴', value: 37 },
                { name: '蓬莱', value: 37 },
                { name: '韶关', value: 38 },
                { name: '嘉峪关', value: 38 },
                { name: '广州', value: 38 },
                { name: '延安', value: 38 },
                { name: '太原', value: 39 },
                { name: '清远', value: 39 },
                { name: '中山', value: 39 },
                { name: '昆明', value: 39 },
                { name: '寿光', value: 40 },
                { name: '盘锦', value: 40 },
                { name: '长治', value: 41 },
                { name: '深圳', value: 41 },
                { name: '珠海', value: 42 },
                { name: '宿迁', value: 43 },
                { name: '咸阳', value: 43 },
                { name: '铜川', value: 44 },
                { name: '平度', value: 44 },
                { name: '佛山', value: 44 },
                { name: '海口', value: 44 },
                { name: '江门', value: 45 },
                { name: '章丘', value: 45 },
                { name: '肇庆', value: 46 },
                { name: '大连', value: 47 },
                { name: '临汾', value: 47 },
                { name: '吴江', value: 47 },
                { name: '石嘴山', value: 49 },
                { name: '沈阳', value: 50 },
                { name: '苏州', value: 50 },
                { name: '茂名', value: 50 },
                { name: '嘉兴', value: 51 },
                { name: '长春', value: 51 },
                { name: '胶州', value: 52 },
                { name: '银川', value: 52 },
                { name: '张家港', value: 52 },
                { name: '三门峡', value: 53 },
                { name: '锦州', value: 54 },
                { name: '南昌', value: 54 },
                { name: '柳州', value: 54 },
                { name: '三亚', value: 54 },
                { name: '自贡', value: 56 },
                { name: '吉林', value: 56 },
                { name: '阳江', value: 57 },
                { name: '泸州', value: 57 },
                { name: '西宁', value: 57 },
                { name: '宜宾', value: 58 },
                { name: '呼和浩特', value: 58 },
                { name: '成都', value: 58 },
                { name: '大同', value: 58 },
                { name: '镇江', value: 59 },
                { name: '桂林', value: 59 },
                { name: '张家界', value: 59 },
                { name: '宜兴', value: 59 },
                { name: '北海', value: 60 },
                { name: '西安', value: 61 },
                { name: '金坛', value: 62 },
                { name: '东营', value: 62 },
                { name: '牡丹江', value: 63 },
                { name: '遵义', value: 63 },
                { name: '绍兴', value: 63 },
                { name: '扬州', value: 64 },
                { name: '常州', value: 64 },
                { name: '潍坊', value: 65 },
                { name: '重庆', value: 66 },
                { name: '台州', value: 67 },
                { name: '南京', value: 67 },
                { name: '滨州', value: 70 },
                { name: '贵阳', value: 71 },
                { name: '无锡', value: 71 },
                { name: '本溪', value: 71 },
                { name: '克拉玛依', value: 72 },
                { name: '渭南', value: 72 },
                { name: '马鞍山', value: 72 },
                { name: '宝鸡', value: 72 },
                { name: '焦作', value: 75 },
                { name: '句容', value: 75 },
                { name: '北京', value: 79 },
                { name: '徐州', value: 79 },
                { name: '衡水', value: 80 },
                { name: '包头', value: 80 },
                { name: '绵阳', value: 80 },
                { name: '乌鲁木齐', value: 84 },
                { name: '枣庄', value: 84 },
                { name: '杭州', value: 84 },
                { name: '淄博', value: 85 },
                { name: '鞍山', value: 86 },
                { name: '溧阳', value: 86 },
                { name: '库尔勒', value: 86 },
                { name: '安阳', value: 90 },
                { name: '开封', value: 90 },
                { name: '济南', value: 92 },
                { name: '德阳', value: 93 },
                { name: '温州', value: 95 },
                { name: '九江', value: 96 },
                { name: '邯郸', value: 98 },
                { name: '临安', value: 99 },
                { name: '兰州', value: 99 },
                { name: '沧州', value: 100 },
                { name: '临沂', value: 103 },
                { name: '南充', value: 104 },
                { name: '天津', value: 105 },
                { name: '富阳', value: 106 },
                { name: '泰安', value: 112 },
                { name: '诸暨', value: 112 },
                { name: '郑州', value: 113 },
                { name: '哈尔滨', value: 114 },
                { name: '聊城', value: 116 },
                { name: '芜湖', value: 117 },
                { name: '唐山', value: 119 },
                { name: '平顶山', value: 119 },
                { name: '邢台', value: 119 },
                { name: '德州', value: 120 },
                { name: '济宁', value: 120 },
                { name: '荆州', value: 127 },
                { name: '宜昌', value: 130 },
                { name: '义乌', value: 132 },
                { name: '丽水', value: 133 },
                { name: '洛阳', value: 134 },
                { name: '秦皇岛', value: 136 },
                { name: '株洲', value: 143 },
                { name: '石家庄', value: 147 },
                { name: '莱芜', value: 148 },
                { name: '常德', value: 152 },
                { name: '保定', value: 153 },
                { name: '湘潭', value: 154 },
                { name: '金华', value: 157 },
                { name: '岳阳', value: 169 },
                { name: '长沙', value: 175 },
                { name: '衢州', value: 177 },
                { name: '廊坊', value: 193 },
                { name: '菏泽', value: 194 },
                { name: '合肥', value: 229 },
                { name: '武汉', value: 273 },
                { name: '大庆', value: 279 }
            ];

            let geoCoordMap = {
                '海门': [121.15, 31.89],
                '鄂尔多斯': [109.781327, 39.608266],
                '招远': [120.38, 37.35],
                '舟山': [122.207216, 29.985295],
                '齐齐哈尔': [123.97, 47.33],
                '盐城': [120.13, 33.38],
                '赤峰': [118.87, 42.28],
                '青岛': [120.33, 36.07],
                '乳山': [121.52, 36.89],
                '金昌': [102.188043, 38.520089],
                '泉州': [118.58, 24.93],
                '莱西': [120.53, 36.86],
                '日照': [119.46, 35.42],
                '胶南': [119.97, 35.88],
                '南通': [121.05, 32.08],
                '拉萨': [91.11, 29.97],
                '云浮': [112.02, 22.93],
                '梅州': [116.1, 24.55],
                '文登': [122.05, 37.2],
                '上海': [121.48, 31.22],
                '攀枝花': [101.718637, 26.582347],
                '威海': [122.1, 37.5],
                '承德': [117.93, 40.97],
                '厦门': [118.1, 24.46],
                '汕尾': [115.375279, 22.786211],
                '潮州': [116.63, 23.68],
                '丹东': [124.37, 40.13],
                '太仓': [121.1, 31.45],
                '曲靖': [103.79, 25.51],
                '烟台': [121.39, 37.52],
                '福州': [119.3, 26.08],
                '瓦房店': [121.979603, 39.627114],
                '即墨': [120.45, 36.38],
                '抚顺': [123.97, 41.97],
                '玉溪': [102.52, 24.35],
                '张家口': [114.87, 40.82],
                '阳泉': [113.57, 37.85],
                '莱州': [119.942327, 37.177017],
                '湖州': [120.1, 30.86],
                '汕头': [116.69, 23.39],
                '昆山': [120.95, 31.39],
                '宁波': [121.56, 29.86],
                '湛江': [110.359377, 21.270708],
                '揭阳': [116.35, 23.55],
                '荣成': [122.41, 37.16],
                '连云港': [119.16, 34.59],
                '葫芦岛': [120.836932, 40.711052],
                '常熟': [120.74, 31.64],
                '东莞': [113.75, 23.04],
                '河源': [114.68, 23.73],
                '淮安': [119.15, 33.5],
                '泰州': [119.9, 32.49],
                '南宁': [108.33, 22.84],
                '营口': [122.18, 40.65],
                '惠州': [114.4, 23.09],
                '江阴': [120.26, 31.91],
                '蓬莱': [120.75, 37.8],
                '韶关': [113.62, 24.84],
                '嘉峪关': [98.289152, 39.77313],
                '广州': [113.23, 23.16],
                '延安': [109.47, 36.6],
                '太原': [112.53, 37.87],
                '清远': [113.01, 23.7],
                '中山': [113.38, 22.52],
                '昆明': [102.73, 25.04],
                '寿光': [118.73, 36.86],
                '盘锦': [122.070714, 41.119997],
                '长治': [113.08, 36.18],
                '深圳': [114.07, 22.62],
                '珠海': [113.52, 22.3],
                '宿迁': [118.3, 33.96],
                '咸阳': [108.72, 34.36],
                '铜川': [109.11, 35.09],
                '平度': [119.97, 36.77],
                '佛山': [113.11, 23.05],
                '海口': [110.35, 20.02],
                '江门': [113.06, 22.61],
                '章丘': [117.53, 36.72],
                '肇庆': [112.44, 23.05],
                '大连': [121.62, 38.92],
                '临汾': [111.5, 36.08],
                '吴江': [120.63, 31.16],
                '石嘴山': [106.39, 39.04],
                '沈阳': [123.38, 41.8],
                '苏州': [120.62, 31.32],
                '茂名': [110.88, 21.68],
                '嘉兴': [120.76, 30.77],
                '长春': [125.35, 43.88],
                '胶州': [120.03336, 36.264622],
                '银川': [106.27, 38.47],
                '张家港': [120.555821, 31.875428],
                '三门峡': [111.19, 34.76],
                '锦州': [121.15, 41.13],
                '南昌': [115.89, 28.68],
                '柳州': [109.4, 24.33],
                '三亚': [109.511909, 18.252847],
                '自贡': [104.778442, 29.33903],
                '吉林': [126.57, 43.87],
                '阳江': [111.95, 21.85],
                '泸州': [105.39, 28.91],
                '西宁': [101.74, 36.56],
                '宜宾': [104.56, 29.77],
                '呼和浩特': [111.65, 40.82],
                '成都': [104.06, 30.67],
                '大同': [113.3, 40.12],
                '镇江': [119.44, 32.2],
                '桂林': [110.28, 25.29],
                '张家界': [110.479191, 29.117096],
                '宜兴': [119.82, 31.36],
                '北海': [109.12, 21.49],
                '西安': [108.95, 34.27],
                '金坛': [119.56, 31.74],
                '东营': [118.49, 37.46],
                '牡丹江': [129.58, 44.6],
                '遵义': [106.9, 27.7],
                '绍兴': [120.58, 30.01],
                '扬州': [119.42, 32.39],
                '常州': [119.95, 31.79],
                '潍坊': [119.1, 36.62],
                '重庆': [106.54, 29.59],
                '台州': [121.420757, 28.656386],
                '南京': [118.78, 32.04],
                '滨州': [118.03, 37.36],
                '贵阳': [106.71, 26.57],
                '无锡': [120.29, 31.59],
                '本溪': [123.73, 41.3],
                '克拉玛依': [84.77, 45.59],
                '渭南': [109.5, 34.52],
                '马鞍山': [118.48, 31.56],
                '宝鸡': [107.15, 34.38],
                '焦作': [113.21, 35.24],
                '句容': [119.16, 31.95],
                '北京': [116.46, 39.92],
                '徐州': [117.2, 34.26],
                '衡水': [115.72, 37.72],
                '包头': [110, 40.58],
                '绵阳': [104.73, 31.48],
                '乌鲁木齐': [87.68, 43.77],
                '枣庄': [117.57, 34.86],
                '杭州': [120.19, 30.26],
                '淄博': [118.05, 36.78],
                '鞍山': [122.85, 41.12],
                '溧阳': [119.48, 31.43],
                '库尔勒': [86.06, 41.68],
                '安阳': [114.35, 36.1],
                '开封': [114.35, 34.79],
                '济南': [117, 36.65],
                '德阳': [104.37, 31.13],
                '温州': [120.65, 28.01],
                '九江': [115.97, 29.71],
                '邯郸': [114.47, 36.6],
                '临安': [119.72, 30.23],
                '兰州': [103.73, 36.03],
                '沧州': [116.83, 38.33],
                '临沂': [118.35, 35.05],
                '南充': [106.110698, 30.837793],
                '天津': [117.2, 39.13],
                '富阳': [119.95, 30.07],
                '泰安': [117.13, 36.18],
                '诸暨': [120.23, 29.71],
                '郑州': [113.65, 34.76],
                '哈尔滨': [126.63, 45.75],
                '聊城': [115.97, 36.45],
                '芜湖': [118.38, 31.33],
                '唐山': [118.02, 39.63],
                '平顶山': [113.29, 33.75],
                '邢台': [114.48, 37.05],
                '德州': [116.29, 37.45],
                '济宁': [116.59, 35.38],
                '荆州': [112.239741, 30.335165],
                '宜昌': [111.3, 30.7],
                '义乌': [120.06, 29.32],
                '丽水': [119.92, 28.45],
                '洛阳': [112.44, 34.7],
                '秦皇岛': [119.57, 39.95],
                '株洲': [113.16, 27.83],
                '石家庄': [114.48, 38.03],
                '莱芜': [117.67, 36.19],
                '常德': [111.69, 29.05],
                '保定': [115.48, 38.85],
                '湘潭': [112.91, 27.87],
                '金华': [119.64, 29.12],
                '岳阳': [113.09, 29.37],
                '长沙': [113, 28.21],
                '衢州': [118.88, 28.97],
                '廊坊': [116.7, 39.53],
                '菏泽': [115.480656, 35.23375],
                '合肥': [117.27, 31.86],
                '武汉': [114.31, 30.52],
                '大庆': [125.03, 46.58]
            };

            let formatter = function (params) {
                // return '项目名称：' + params.value[6] + '<br/>' + "<div class='map-dot-black'></div>" + '设备数量：' + params.value[2]
                return `<div class='map-tooltip'>
                            <span class='project-name'>${params.value[6]}</span>
                            <div class='tooltip-data'>
                                <div class='map-dot black'></div>
                                <span class='tooltip-text'>设备数量：</span>${params.value[2]}
                            </div>
                            <div class='tooltip-data'>
                                <div class='map-dot blue'></div>
                                <span class='tooltip-text'>昨日用水量：</span>${params.value[3]}（t）
                            </div>
                            <div class='tooltip-data'>
                                <div class='map-dot yellow'></div>
                                <span class='tooltip-text'>昨日用电量：</span>${params.value[4]}（kw·h）
                            </div>
                            <div class='tooltip-data'>
                                <div class='map-dot red'></div>
                                <span class='tooltip-text'>昨日燃气用量：</span>${params.value[5]}（m³）
                            </div>
                        </div>`
            };
            let that = this
            let convertData = function (data) {
                let res = [];
                for (let i = 0; i < data.length; i++) {
                    let geoCoord = that.geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value.deviceNum).concat(data[i].value.waterNum).concat(data[i].value.electricNum).concat(data[i].value.gasNum).concat(data[i].projectName),
                            tooltip: {
                                borderWidth: 0,
                                backgroundColor: 'rgba(0,0,0,0)',
                                padding: 0,
                                formatter: formatter
                            }
                        });
                    }
                }
                return res;
            };



            let option = {
                geo: {
                    //引入中国的地图
                    map: 'china',
                    left: 70,
                    top: 10,
                    right: 100,
                    bottom: 10,
                    label: {
                        normal: {
                            show: false  //省份名称
                        },
                        emphasis: {//鼠标放上 中间字体显示，并且颜色变化
                            show: true
                        },
                    },
                    roam: true,
                    zoom: 1,
                    itemStyle: {
                        normal: {
                            borderWidth: .5,//区域边框宽度
                            borderColor: '#FFF',//区域边框颜色
                            areaColor: "#fadb9b",//区域颜色
                        },
                        emphasis: {
                            borderWidth: .2,
                            borderColor: '#FFF',
                            areaColor: "#17f0cc",//fadb9b
                        }
                    },
                },

                tooltip: {
                    trigger: 'item',
                    // formatter: formatter,
                },

                // 左侧小导航图标
                // visualMap: {
                //     show: false,
                //     // x: 'left',
                //     // y: 'center',
                //     // splitList: [
                //     //     { start: 500, end: 600 }, { start: 400, end: 500 },
                //     //     { start: 300, end: 400 }, { start: 200, end: 300 },
                //     //     { start: 100, end: 200 }, { start: 0, end: 100 },
                //     // ],
                //     // color: ['#002467', '#003088', '#1551aa', '#286ec2', '#4090de', '#70c1ff'],

                //     min: 0,
                //     max: this.mapData[0].value,
                //     // text: ['High', 'Low'],
                //     realtime: false,
                //     calculable: true,
                //     inRange: {
                //         // color: this.mapColor
                //         color: ['#999', '#fadb9b', '#000']
                //     }
                // },
                //配置属性
                series: [
                    {
                        name: 'pm2.5',
                        type: 'scatter',
                        coordinateSystem: 'geo',
                        data: convertData(this.mapData),
                        encode: {
                            value: 2,
                            // tooltip:[2,3,4]
                        },
                        // symbol:'',
                        symbolSize: 8,
                        // symbolSize: function (val) {
                        //     return val[2] * 5;
                        // },
                        label: {
                            // show:true,
                            formatter: '{b}',
                            position: 'right'
                        },
                        itemStyle: {
                            color: '#ED4C00'
                        },
                        emphasis: {
                            label: {
                                show: true
                            }
                        }
                    },
                    // {
                    //     name: '计划单列市',
                    //     type: 'scatter',//影响散点
                    //     coordinateSystem: 'geo',
                    //     symbolSize: 12,
                    //     showEffectOn: 'render',
                    //     rippleEffect: {
                    //         brushType: 'stroke'
                    //     },
                    //     hoverAnimation: true,
                    //     label: {
                    //         normal: {
                    //             color: '#c60fff',
                    //             formatter: '{b}',
                    //             position: 'right',
                    //             show: false
                    //         },
                    //         emphasis: {
                    //             show: true
                    //         }
                    //     },
                    //     itemStyle: {
                    //         normal: {
                    //             color: '',
                    //             shadowBlur: 10,
                    //             shadowColor: '#333'
                    //         },
                    //     },
                    //     data: data,
                    // }
                ]
            };


            myChart.setOption(option);
        },


        getEchartMap1111() {
            var myChart = echarts.init(document.getElementById('echartMap'));
            var geoCoordMap = {//自定义城市坐标
                "青岛": [120.33, 36.07],
                "厦门": [118.1, 24.46],
                "宁波": [121.56, 29.86],
                "深圳": [114.07, 22.62],
                "大连": [121.62, 38.92]
            };

            var convertData = function (data) {
                var res = [];
                for (var i = 0; i < data.length; i++) {
                    var geoCoord = geoCoordMap[data[i].name];
                    if (geoCoord) {
                        res.push({
                            name: data[i].name,
                            value: geoCoord.concat(data[i].value)
                        });
                    }
                }
                return res;
            };
            let option = {
                // backgroundColor: '#BBFFFF',
                // title: {
                //     text: '异常分布',
                //     x: 'center'
                // },
                // tooltip: {
                //     trigger: 'item',
                //     formatter: function (params) {
                //         var res = params.name + '<br/>';
                //         var myseries = option.series;
                //         if (convertData) {
                //             for (var i = 0; i < myseries.length - 1; i++) {
                //                 for (var j = 0; j < myseries[i].data.length; j++) {
                //                     if (myseries[i].data[j].name == params.name) {
                //                         res += myseries[i].name + ' : ' + myseries[i].data[j].value + '</br>';
                //                     }
                //                 }
                //             }
                //         }
                //         else {
                //             for (var i = 0; i < myseries.length; i++) {
                //                 for (var j = 0; j < myseries[i].data.length; j++) {
                //                     if (myseries[i].data[j].name == params.name) {
                //                         res += myseries[i].name + ' : ' + myseries[i].data[j].value + '</br>';
                //                     }
                //                 }
                //             }
                //         }
                //         return res;
                //     }
                // },
                legend: {
                    orient: 'vertical',
                    x: 'left',
                    data: ['超时', '失败', '运行中']
                },
                // dataRange: {
                //     min: 0,
                //     max: 30,
                //     x: 'left',
                //     y: 'bottom',
                //     color: ['red', 'orange', 'yellow', 'green'],
                //     text: ['高', '低'],
                //     calculable: true
                // },
                // toolbox: {
                //     show: true,
                //     orient: 'vertical',
                //     x: 'right',
                //     y: 'center',
                //     feature: {
                //         mark: { show: true },
                //         dataView: { show: true, readOnly: false },
                //         restore: { show: true },
                //         saveAsImage: { show: true }
                //     }
                // },
                roamController: {
                    show: true,
                    x: 'right',
                    mapTypeControl: {
                        'china': true
                    }
                },
                geo: {
                    map: 'china',
                    label: {
                        emphasis: {
                            show: true
                        }
                    },
                    itemStyle: {
                        normal: {
                            areaColor: '#fadb9b',
                            borderColor: '#84C1FF',
                            borderWidth: 0.8
                        },
                        emphasis: {
                            areaColor: '#FFC78E'
                        }
                    }
                },
                series: [
                    // {
                    //     name: '超时',
                    //     type: 'map',
                    //     mapType: 'china',
                    //     roam: false,
                    //     itemStyle: {
                    //         normal: { label: { show: false } },
                    //         emphasis: { label: { show: true } }
                    //     },
                    //     data: [
                    //         { name: '广东', value: 4 },
                    //         { name: '黑龙江', value: 1 },
                    //         { name: '湖南', value: 3 }
                    //     ]
                    // },
                    // {
                    //     name: '失败',
                    //     type: 'map',
                    //     mapType: 'china',
                    //     itemStyle: {
                    //         normal: { label: { show: false } },
                    //         emphasis: { label: { show: true } }
                    //     },
                    //     data: [
                    //         { name: '安徽', value: 11 },
                    //         { name: '北京', value: 1 },
                    //         { name: '大连', value: 13 },
                    //         { name: '福建', value: 6 },
                    //         { name: '甘肃', value: 1 },
                    //         { name: '广东', value: 4 },
                    //         { name: '广西', value: 10 },
                    //         { name: '贵州', value: 9 },
                    //         { name: '海南', value: 4 },
                    //         { name: '河北', value: 1 },
                    //         { name: '河南', value: 18 },
                    //         { name: '黑龙江', value: 1 },
                    //         { name: '湖北', value: 3 },
                    //         { name: '湖南', value: 18 },
                    //         { name: '吉林', value: 16 },
                    //         { name: '江苏', value: 16 },
                    //         { name: '江西', value: 24 },
                    //         { name: '辽宁', value: 1 },
                    //         { name: '内蒙古', value: 18 },
                    //         { name: '宁波', value: 12 },
                    //         { name: '宁夏', value: 1 },
                    //         { name: '青岛', value: 2 },
                    //         { name: '青海', value: 23 },
                    //         { name: '山东', value: 14 },
                    //         { name: '山西', value: 8 },
                    //         { name: '陕西', value: 13 },
                    //         { name: '上海', value: 10 },
                    //         { name: '深圳', value: 4 },
                    //         { name: '四川', value: 8 },
                    //         { name: '天津', value: 28 },
                    //         { name: '西藏', value: 2 },
                    //         { name: '厦门', value: 5 },
                    //         { name: '新疆', value: 4 },
                    //         { name: '云南', value: 10 },
                    //         { name: '浙江', value: 13 },
                    //         { name: '重庆', value: 18 }
                    //     ],
                    // },
                    // {
                    //     name: '运行中',
                    //     type: 'map',
                    //     mapType: 'china',
                    //     itemStyle: {
                    //         normal: { label: { show: false } },
                    //         emphasis: { label: { show: true } }
                    //     },
                    //     data: [
                    //         { name: "青岛", value: 1 },
                    //         { name: "厦门", value: 23 },
                    //         { name: "宁波", value: 12 },
                    //         { name: "深圳", value: 4 },
                    //         { name: "大连", value: 13 },
                    //     ]
                    // },
                    {
                        name: '计划单列市',
                        type: 'effectScatter',//影响散点
                        coordinateSystem: 'geo',
                        symbolSize: 12,
                        showEffectOn: 'render',
                        rippleEffect: {
                            brushType: 'stroke'
                        },
                        hoverAnimation: true,
                        label: {
                            normal: {
                                color: '#c60fff',
                                formatter: '{b}',
                                position: 'right',
                                show: false
                            },
                            emphasis: {
                                show: true
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '',
                                shadowBlur: 10,
                                shadowColor: '#333'
                            },
                        },
                        data: convertData([
                            { name: "青岛" },
                            { name: "厦门" },
                            { name: "宁波" },
                            { name: "深圳" },
                            { name: "大连" },
                        ]),
                    }
                ]
            };
            myChart.setOption(option);
            // myChart.on('mouseover', function (params) {
            //     var dataIndex = params.dataIndex;
            //     console.log(params);
            // });

            // window.addEventListener("resize", function () {
            //     myChart.resize();
            // })
        },

        // 设备类型占比
        getTypeCount() {
            getTypeCount().then(res => {
                if (res.code == 200) {
                    let { data } = res
                    this.typeData = []
                    data.forEach(el => {
                        this.typeData.push({
                            name: el.device_type_name,
                            value: el.count
                        })
                    })
                    this.getDeviceTypeEchart()
                }
            })
        },
        //设备类型占比
        getDeviceTypeEchart() {
            let myChart = echarts.init(document.getElementById('typeEchart'));
            let option = {
                color: ['#00B4FF', '#00D49B', '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    orient: 'vertical',
                    right: '5%',
                    icon: "circle",//形状  类型包括 circle,rect,line，roundRect，triangle，diamond，pin，arrow，none
                },
                series: [
                    {
                        // name: '设备类型',
                        name: '',
                        type: 'pie',
                        center: ['40%', '50%'],
                        radius: ['45%', '65%'],
                        avoidLabelOverlap: false,
                        label: {
                            show: true,
                            formatter: '{d}%'
                        },
                        labelLine: {
                            show: true,
                            length2: 40,
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '17',
                            }
                        },

                        data: this.typeData,
                    }
                ]
            };
            myChart.setOption(option);
        },

        //设备分布TOP10地域
        getDeviceDistributionEchart() {
            let option = {
                color: ['#00D49B', '#00B4FF'],
                grid: {
                    top: '5%',
                    left: '3%',
                    right: '4%',
                    bottom: '8%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    // formatter: '{b} <br /> 设备数量：{c}'
                },
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    // data: ['湖南', '湖北', '北京', '重庆', '上海', '西安', '衡水', 'AUG', 'OCT', 'NOV', 'JUN']
                    data: this.regionNameArr
                },
                series: [{
                    // data: [120, 200, 150, 80, 70, 110, 130, 150, 80, 70, 110, 130],
                    name: '设备数量',
                    data: this.countArr,
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [0, 15, 15, 0]
                        }
                    },
                }]
            };

            // let myChart = echarts.init(document.getElementById('distributionEchart'));
            // myChart.setOption(option);



            let that = this
            setTimeout(() => {
                that.$nextTick(() => {
                    let myChart = echarts.init(document.getElementById('distributionEchart'));
                    myChart.setOption(option);
                })
            }, 0)

            // this.$nextTick(() => {
            //     setTimeout(() => {
            //         let myChart = echarts.init(document.getElementById('distributionEchart'));
            //         myChart.setOption(option);
            //     }, 100)
            // })
        },


        //能耗排行
        async getEnergyRanking() {
            const res = await getEnergyRanking('day')
            if (res.code == 200) {
                let data = res.data.comprehensiveRakingVo
                data.sort((a, b) => { return a.value - b.value })
                this.energyRankingName = []
                this.energyRankingData = []
                data.slice(-10).forEach(el => {
                    this.energyRankingName.push(el.name)
                    this.energyRankingData.push(el.value)
                })
                this.getRankingListEchart()
            }
        },

        //能耗排行
        getRankingListEchart() {
            let option = {
                color: ['#00D49B', '#00B4FF'],
                grid: {
                    top: '5%',
                    left: '3%',
                    right: '4%',
                    bottom: '8%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                },
                xAxis: {
                    type: 'value'
                },
                yAxis: {
                    type: 'category',
                    axisLabel: {
                        formatter: function (params) {
                            var val = "";
                            if (params.length > 6) {
                                val = params.substr(0, 6) + '...';
                                return val;
                            } else {
                                return params;
                            }
                        }
                    },
                    // data: ['湖南', '湖北', '北京', '重庆', '上海', '西安', '衡水', 'AUG', 'OCT', 'NOV', 'JUN']
                    data: this.energyRankingName
                },
                series: [{
                    // data: [120, 220, 150, 80, 70, 110, 130, 150, 80, 70, 110, 130],
                    name: '综合能耗（kgce）',
                    data: this.energyRankingData,
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            barBorderRadius: [0, 15, 15, 0]
                        }
                    },
                }]
            };

            let myChart = echarts.init(document.getElementById('rankingListEchart'));
            myChart.setOption(option);
        },






        findall(a, x) {//查找数组中某个值出现的所有下标
            let results = [],
                len = a.length,
                pos = 0;
            while (pos < len) {
                pos = a.indexOf(x, pos);
                if (pos === -1) {//未找到就退出循环完成搜索
                    break;
                }
                results.push(pos);//找到就存储索引
                pos += 1;//并从下个位置开始搜索
            }
            return results;
        },
    },
}
